import React from "react";
import { USER_TYPES } from "../constants";
import { getNameAbbreviation } from "rylak-common";
import { getBrandName } from "./brandCore";

export function getUserDisplayFirstName({ user }) {
    const displayName = getUserDisplayName({ user })?.trim();
    const firstName = displayName?.split(" ")?.[0];
    return firstName;
}

export function getUserDisplayName({ user }) {
    return (user?.displayName || getUserUsername({ user }))?.trim();
}

export function getUserUsername({ user }) {
    return user?.username;
}

export function getUserEmail({ user }) {
    return user?.email;
}

export function getUserQualityCheckReturnStations({ user }) {
    return user?.qualityCheckReturnStations;
}

export function getReadableUserType({ user }) {
    const { merchant, merchantBrand, shipmentCarrier, type } = user;
    const label =
        type === USER_TYPES.SHOP
            ? "Shop" //getBrandName(merchantBrand)
            : type === USER_TYPES.SHOP_GROUP
              ? "Shop Group" //merchant?.name
              : type === USER_TYPES.SHIPMENT_CARRIER
                ? "Carrier" //shipmentCarrier
                : type === USER_TYPES.TURNR
                  ? "Ingrid"
                  : "";

    const entity = type === USER_TYPES.SHOP ? getBrandName(merchantBrand) : type === USER_TYPES.SHOP_GROUP ? merchant?.name : type === USER_TYPES.SHIPMENT_CARRIER ? shipmentCarrier : "";

    return (
        <div
            style={{
                gap: "10px",
            }}
        >
            <div className={"muted"}>{label}</div>
            <div>{entity}</div>
        </div>
    );
}

export function getUserAbbreviation({ user }) {
    const displayName = getUserDisplayName({ user })?.trim();
    return getNameAbbreviation({ name: displayName });
}

function stringToHslColor(str, s, l) {
    var hash = 0;
    for (var i = 0; i < str?.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    var h = hash % 360;
    return "hsl(" + h + ", " + s + "%, " + l + "%)";
}

export function userNameToColor({ user }) {
    return stringToHslColor(getUserUsername({ user }) || getUserDisplayName({ user }), 30, 70);
}
